import $ from 'jquery';
import Swal from 'sweetalert2';
import {ajaxCall} from '../includes/functions';

jQuery(function($){
    $('form.form-nc-login').on('submit', function(e){
        e.preventDefault();
        e.target.querySelector('button[type=submit]').disabled = true;
        
        let data = {
            action: 'kbc_login_form',
            username: $(this).find('input[name="email"]').val(),
            password: $(this).find('input[name="password"]').val(),
            remember: $(this).find('input[name="remember"]').is(':checked'),
        };

        // check get prebooking value
        let getParams = new URLSearchParams(window.location.search);
        if( getParams.has('prebooking') )
            data.prebooking = getParams.get('prebooking');

        if( getParams.has('tourId') )
            data.tourId = getParams.get('tourId');

        ajaxCall( data ).then( resp=>{
            if( resp.status == false )
            {
                Swal.fire( 'Something went wrong', resp.error, 'error');
                e.target.querySelector('button[type=submit]').disabled = false;
                return;
            }
            window.location.reload();
        });
        
    });
});